module.exports = __webpack_public_path__ + "2e98c61cab19b0e0a3ff8de31efc5930.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-wizard.png
// module id = 970
// module chunks = 0